import React from "react";
import Header from "@/components/Header";
import bwmodel from '@/config/bwmodel';
import styles from '@/styles'
import styled from "styled-components";
import { jumpTo } from "../../utils";


export const isStorm = bwmodel.app === 'storm';
const Rule = () => {
  
  return <div>

  {isStorm && 
    <Header
      title="活动规则"
      hideNaviBar
      bg_color={styles.bg_color2}
      right={
        <div 
          onClick={()=> {
            jumpTo('https://m.wogoo.com/serviceCode');
          }}
        >联系客服</div>
      }
    />
  }
  <Container>
  <h2>一、活动时间：</h2>
  <p>2024年09月12日-2024年10月18日；</p>

  <h2>二、活动人群：</h2>
  <p>所有用户均可参与；</p>
  
  <h2>三、活动规则</h2>
  <p>在活动期间通过本活动页购买会员都可参与<span style={{color: '#FF3E4C'}}>1999元任选2个年会员、2998元任选3个年会员，3888元打包所有会员；</span></p>
  <p>任选的会员在单次购买时无法重复选择，支持分两次购买相同的会员；</p>
  <p>打包所有年会员等同于购买“风云大会员·年卡”，会同时解锁所有会员，会将所有会员都增加372天有效天数；</p>
  <p>本次活动可任选的会员：研报畅读/短线挖掘/吾股复盘/红绿波段/跳空异动/一阳指/趋势拐点/吾股排名，共8个年会员；</p>
  <p>购买年会员初始有效天数都设置为：372天；</p>
  <p>除此之外，购买任意会员都会额外赠送“锦鲤卡”会员。</p>
  
  <h2>四、附加福利</h2>
  <p>1）大鳄周边1套（数量有限）：在购买时，购物车有自动带上“大鳄周边1套”，在购买成功后都可选择1套大鳄周边（1个帆布包+1个杯子），库存有限，送完为止；</p>
  <p>记得在下单成功后根据页面提示选择想要的周边和填写收货地址～</p>
  <p>2）赠送天数（随机触发）：用户在活动页有显示“赠送会员天数”，在赠送会员天数的有效期内下单成功，都会在所购买的会员上加上赠送的会员天数；也就是购买的所有会员实际到账天数为：初始天数372天+赠送会员天数。</p>
  <p>例：购买了“研报畅读&短线挖掘&吾股复盘”3个会员，购买时有显示送10天，那购买成功后3个会员有效天数都为372天+送10天（共382天）。</p>
  
  <h2>五、奖励发放时间：</h2>
  <p>1）会员购买成功后，会员天数会自动发放到账户中，如有赠送会员天数，也会合并一起发放；</p>
  <p>2）大鳄周边，由于周边奖品为实物，需要采购&邮寄等流程，我们会统一安排在活动结束后10个工作日内发放，快递发放前会通过短信先与您联系，请注意查收短信；</p>

  <h2>六、其他说明</h2>
  <p>1）对于以任何不正当方式参与活动的用户。包括但不限干侵犯第三人合法权益、作弊、扰乱系统、实施网络攻击、批量注册、用机器注册账户、用机器模拟客户端等，市值风云有权取消其参与和获得各种奖励的资格，对于非法所得，保留将各种奖励扣回的权利，并对账号进行永久限制。</p>
  <p>2）本活动最终解释权归市值风云所有。</p>
  <p>3）本活动与Apple Inc无关.</p>

</Container>
</div>
}

export default Rule;

const Container = styled.div`
  padding:44px 10px;
`


// WEBPACK FOOTER //
// ./src/views/activity_135/rules.js